export const toggleValue = (value: string[], newValue: string): string[] => {
  if (value.includes(newValue)) {
    return value.filter((id) => id !== newValue)
  }

  return [...value, newValue]
}
